import type { MonitoringClient } from './MonitoringClient';

export class NoOpMonitoringClient implements MonitoringClient {
	public submitError(): void {}
	public updateContext(): void {}
	public incrementCounter(): void {}
	public gauge(): void {}
}
